import LLink from "@components/LLink";
import { Stack } from "expo-router";
import React from "react";
import { StyleSheet, Text, View } from "react-native";
import { useNavigationStore } from "@utils/navigation/useNavigationStore";

const DefaultComponent = () => {
  const pathname = useNavigationStore((state) => state.currentPath);
  return (
    <>
      <Stack.Screen
        options={{ title: "Oops!", presentation: "fullScreenModal" }}
      />
      <View style={styles.container}>
        <Text style={styles.title}>This screen doesn&apos;t exist</Text>
        <Text style={styles.title}>{pathname}</Text>

        <LLink href="/" style={styles.link} pressable={false}>
          <Text style={styles.linkText}>Back to home</Text>
        </LLink>
      </View>
    </>
  );
};

export default function NotFoundScreen() {
  return <DefaultComponent />;
}

const styles = StyleSheet.create({
  container: {
    flex: 1,
    alignItems: "center",
    justifyContent: "center",
    padding: 20,
  },
  title: {
    fontSize: 20,
    fontWeight: "bold",
    color: "white",
  },
  link: {
    marginTop: 15,
    paddingVertical: 15,
  },
  linkText: {
    fontSize: 14,
    color: "#2e78b7",
  },
});
